<section class="content info">
  <div class="capa">
    <div class="container">
      <div class="row">
        <div class="col-12 custom-col">
          <div class="texto">
            <p>
              <span>Como</span>
            </p>
            <p>
              <span>Posso</span>
            </p>
            <p>
              <span>Te Ajudar?</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>